import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedOffer: null,
};

const historyTabSlice = createSlice({
  name: 'historyTab',
  initialState,
  reducers: {
    setSelectedOffer(state, action) {
      state.selectedOffer = action.payload;
    },
    clearSelectedOffer(state) {
      state.selectedOffer = null;
    },
  },
});

export const { setSelectedOffer, clearSelectedOffer } = historyTabSlice.actions;

export const selectHistoryTabSelectedOffer = (state) => state.historyTab.selectedOffer;

export default historyTabSlice.reducer;
